import { Controller } from "stimulus";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";

export default class extends Controller {
  dispatch(event) {
    event.preventDefault();
    dispatchCustomEvent(document, this.eventName);
  }

  dispatchWithQueryString(event) {
    event.preventDefault();
    dispatchCustomEvent(document, this.eventName, true, true, { queryString: this.queryString });
  }

  get queryString() {
    return this.element.dataset.queryString;
  }

  get eventName() {
    return this.element.dataset.eventName;
  }
}
